// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3Ainz","rootSmall":"AddTileButton_rootSmall__307Ny"};